import { CarouselComponent } from '@builder.io/widgets/dist/lib/components/Carousel';

export default CarouselComponent;
